
<template>
  <CustomersDetail></CustomersDetail>
</template>

<script>
import CustomersDetail from './customersDetail.vue';


export default {
  components:{CustomersDetail}
}
</script>



// WEBPACK FOOTER //
// src/pages/customer/opportunitiesDetail.vue